module.exports = __webpack_public_path__ + "static/media/Cedric Diggory 1.3a5cc2b0.jpg";